import apiClient from "./api";
import { getApiAccessToken } from "./UserService";

const baseUrl = "/api/Subscribers";

export interface Subscriber {
  id: number;
  name: string;
  email?: string | null;
  addressSystemId: number;
  invoiceReference?: string | null;
  organization1?: string | null;
  organization2?: string | null;
  substituteSubscriberId?: number | null;
  substituteSubscriberName?: string | null;
  isApprover: boolean;
  userId?: number | null;
  userName?: string | null;
  isActive: boolean;
  isInUse: boolean;
}

export interface SubscriberOption {
  id: number;
  name: string;
  email?: string | null;
}

export interface SubscriberMetadata {
  subscriberOptions: SubscriberOption[];
  userOptions: SubscriberOption[];
}

export interface UpsertSubscriberRequest {
  name: string;
  email?: string | null;
  invoiceReference?: string | null;
  organization1?: string | null;
  organization2?: string | null;
  substituteSubscriberId?: number | null;
  isApprover: boolean;
  userId?: number | null;
  isActive: boolean;
}

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const getSubscribers = async (
  addressSystemId: number,
): Promise<Subscriber[]> => {
  const headers = await authHeader();
  const response = await apiClient.get<Subscriber[]>(
    `${baseUrl}/${addressSystemId}`,
    { headers },
  );
  return response.data;
};

export const getSubscriberMetadata = async (
  addressSystemId: number,
): Promise<SubscriberMetadata> => {
  const headers = await authHeader();
  const response = await apiClient.get<SubscriberMetadata>(
    `${baseUrl}/${addressSystemId}/metadata`,
    { headers },
  );
  return response.data;
};

export const createSubscriber = async (
  addressSystemId: number,
  request: UpsertSubscriberRequest,
): Promise<number> => {
  const headers = await authHeader();
  const response = await apiClient.post<{ id: number }>(
    `${baseUrl}/${addressSystemId}`,
    request,
    { headers },
  );
  return response.data.id;
};

export const updateSubscriber = async (
  addressSystemId: number,
  subscriberId: number,
  request: UpsertSubscriberRequest,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.put(`${baseUrl}/${addressSystemId}/${subscriberId}`, request, {
    headers,
  });
};

export const deleteSubscriber = async (
  addressSystemId: number,
  subscriberId: number,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.delete(`${baseUrl}/${addressSystemId}/${subscriberId}`, {
    headers,
  });
};
